import { ensureApiArray } from './taskTracker.api.mappers.utils'
import type {
  ApiTaskTrackerReferenceDealNode,
  ApiTaskTrackerReferenceFunnelNode,
  ApiTaskTrackerReferenceLeadNode,
  ApiTaskTrackerReferencesTreeResponse,
} from './taskTracker.references.api.types'
import type {
  TaskTrackerCrmLeadDealNode,
  TaskTrackerCrmLeadFunnelNode,
  TaskTrackerCrmLeadTreeItem,
  TaskTrackerCrmLeadTreePage,
} from '../lib/taskTrackerCrmLeadSticker.types'

const mapDealNode = (
  item: ApiTaskTrackerReferenceDealNode,
): TaskTrackerCrmLeadDealNode | null => {
  const leadFunnelId = Number(item.lead_funnel_id)
  if (!Number.isFinite(leadFunnelId) || leadFunnelId <= 0) return null

  const deal = item.deal
  const status = item.current_status

  return {
    leadFunnelId,
    dealId: deal?.id != null ? Number(deal.id) : null,
    dealName: deal?.name != null ? String(deal.name).trim() : null,
    statusName: status?.name != null ? String(status.name).trim() : null,
    statusColor: status?.color != null ? String(status.color).trim() : null,
    managerId:
      item.manager_id != null && Number.isFinite(Number(item.manager_id))
        ? Number(item.manager_id)
        : null,
  }
}

const mapFunnelNode = (
  item: ApiTaskTrackerReferenceFunnelNode,
): TaskTrackerCrmLeadFunnelNode | null => {
  const funnelId = Number(item.funnel_id ?? item.funnel?.id)
  if (!Number.isFinite(funnelId) || funnelId <= 0) return null

  const funnelName =
    item.funnel?.name != null ? String(item.funnel.name).trim() : null

  return {
    funnelId,
    funnelName: funnelName || null,
    deals: ensureApiArray(item.deals)
      .map(mapDealNode)
      .filter((deal): deal is TaskTrackerCrmLeadDealNode => deal != null),
  }
}

const mapLeadNode = (
  item: ApiTaskTrackerReferenceLeadNode,
): TaskTrackerCrmLeadTreeItem | null => {
  const leadId = Number(item.lead_id ?? item.lead?.id)
  if (!Number.isFinite(leadId) || leadId <= 0) return null

  const lead = item.lead
  const name = lead?.name != null ? String(lead.name).trim() : null
  const phone = lead?.phone != null ? String(lead.phone).trim() : null
  const email = lead?.email != null ? String(lead.email).trim() : null

  return {
    leadId,
    name: name || null,
    phone: phone || null,
    email: email || null,
    funnels: ensureApiArray(item.funnels)
      .map(mapFunnelNode)
      .filter((funnel): funnel is TaskTrackerCrmLeadFunnelNode => funnel != null),
  }
}

export const mapCrmLeadReferencesTreeFromApi = (
  data: ApiTaskTrackerReferencesTreeResponse | null | undefined,
): TaskTrackerCrmLeadTreePage => {
  const nextCursorRaw = data?.next_cursor
  const nextCursor =
    nextCursorRaw != null && String(nextCursorRaw).trim() !== ''
      ? String(nextCursorRaw).trim()
      : null

  return {
    items: ensureApiArray(data?.items)
      .map(mapLeadNode)
      .filter((item): item is TaskTrackerCrmLeadTreeItem => item != null),
    nextCursor,
    totalCount: Number(data?.total_count) || 0,
  }
}
